import axios from "axios";
import React, { useState } from "react";
import { api } from "../base_url";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
const emailRegex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
import eysofficon from "../../assets/images/eyefill.png";

function Create_password() {
  const [password2, setpassword2] = useState(true);
  const [password3, setpassword3] = useState(true);
  const [hide, sethide] = useState(false);
  const [verifytoken, setverifytoken] = useState("");
  const [createpass, setcreatepass] = useState(false);
  const [message, setmessage] = useState("");
  const navigate = useNavigate();
  const { verify_token } = useParams();
  const [contact, setcontact] = useState({
    email: "",
    newpass: "",
    newpassconfirm: "",
    otp: "",
  });
  const [errorfield, seterrorfield] = useState({
    email: "",
    otp: "",
    newpass: "",
    newpassconfirm: "",
  });
  console.log(contact?.email);

  const createNewpass = async () => {
    if (contact.newpass === "" || contact.newpassconfirm === "") {
      toast.error("Please enter a new password and confirm it.");
      return;
    }
    let data = JSON.stringify({
      password: contact?.newpass,
      verify_token: verify_token,
      password_confirmation: contact?.newpassconfirm,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: api + "/api/createNewPassword",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    if (contact?.newpass == contact?.newpassconfirm) {
      await axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          if (response.data?.status == true) {
            toast.success(response.data?.message);
            setTimeout(() => {
              navigate("/login");
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
          // toast.error(error.message)
        });
    } else {
      toast.error("Password and Confirm Password Must Be Same !");
    }
  };

  const logins_field2 = (e) => {
    switch (e.target.name) {
      case "email":
        errorfield.email = emailRegex.test(e.target.value)
          ? ""
          : "Email not valid.";
        break;
      case "otp":
        errorfield.otp = e.target.value ? "" : "Email not valid.";
        break;

      default:
        break;
    }
    seterrorfield({ ...errorfield });
    setcontact({ ...contact, [e.target.name]: e.target.value });
  };
  const logins_field = (e) => {
    console.log(e);
    switch (e) {
      case "email":
        errorfield.email = contact.email == "" ? "required" : "";
        break;
      case "otp":
        errorfield.otp = contact.otp == "" ? "required" : "";
        break;
      default:
        break;
    }
    seterrorfield({ ...errorfield });
    // setcontact({ ...contact, [e.target.name]: e.target.value })
  };

  return (
    <>
      <div className="breadcrumbs">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/login"> Sign in</a>
            </li>

            <li>
              <a href="#">
                <span>Create New Password</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="forget-password font-lg">
        <div className="container">
          <h1 data-aos="fade-up">Create New Password</h1>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12 col-md-offset-4" data-aos="fade-up">
              <div className="panel panel-default">
                <div className="text-center">
                  <h3> Create New Password</h3>
                  <div className="panel-body">
                    <form className="form" autoComplete="off">
                      <div className="form-group ">
                        <div className="input-group input-box2 input-box">
                          <input
                            id="newpass"
                            name="newpass"
                            onChange={(e) => logins_field2(e)}
                            placeholder="Enter New Password *"
                            className="form-control"
                            type={password2 ? "password" : "text"}
                            autoComplete="off"
                            style={
                              errorfield.newpass == ""
                                ? {}
                                : { borderBottom: "1px solid red" }
                            }
                          />

                          {password2 == true ? (
                            <span
                              toggle="#password-field"
                              className="eys_icon1"
                              onClick={(e) => setpassword2(!password2)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                              >
                                <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
                              </svg>
                            </span>
                          ) : (
                            <span
                              toggle="#password-field"
                              className="eys_icon1"
                              onClick={(e) => setpassword2(!password2)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                              >
                                <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
                              </svg>
                            </span>
                          )}
                          {/* <img src={eysofficon}/> */}

                          <input
                            name="newpassconfirm"
                            onChange={(e) => logins_field2(e)}
                            placeholder="Enter Confirm Password *"
                            className="form-control"
                            type={password3 ? "password" : "text"}
                            autoComplete="off"
                            style={
                              errorfield.newpassconfirm == ""
                                ? { marginTop: "12px" }
                                : {
                                    borderBottom: "1px solid red",
                                    marginTop: "12px",
                                  }
                            }
                          />
                          {password3 ? (
                            <span
                              toggle="#password-field"
                              className="eys_icon2"
                              onClick={(e) => setpassword3(!password3)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                              >
                                <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
                              </svg>
                            </span>
                          ) : (
                            <span
                              toggle="#password-field"
                              className="eys_icon2"
                              onClick={(e) => setpassword3(!password3)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                              >
                                <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
                              </svg>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          // name="recover-submit"
                          onClick={() => {
                            if (errorfield.email == "") {
                              createNewpass();
                              console.log("clicked");
                            } else {
                              logins_field("newpass");
                              console.log("clicked 444");

                              //   errorfield.email = "required";
                            }
                          }}
                          className="btn btn-lg btn-secondary btn-block"
                          type="button"
                        >
                          Submit
                        </button>
                        {/* </a> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </>
  );
}

export default Create_password;
